import React from "react";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { CheckinSettingsResponse } from "@/types/booking-checkin-settings";

const Label = ({ children, className }: any) => (
  <label className={`text-2xl font-normal ${className || ""}`}>
    {children}
  </label>
);

interface DocumentTabProps {
  settings: CheckinSettingsResponse | null;
  setSettings: React.Dispatch<
    React.SetStateAction<CheckinSettingsResponse | null>
  >;
}

export const DocumentTab = ({ settings, setSettings }: DocumentTabProps) => {
  const updateSetting = (
    key: keyof CheckinSettingsResponse,
    value: CheckinSettingsResponse[keyof CheckinSettingsResponse],
  ) => {
    setSettings((previousSettings) =>
      previousSettings
        ? {
            ...previousSettings,
            [key]: value,
          }
        : previousSettings,
    );
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.isShowDocumentVerification}
          onCheckedChange={(checked) =>
            updateSetting("isShowDocumentVerification", checked)
          }
        />
        <Label className="text-2xl">Document verification</Label>
      </div>

      <div className="ml-12 space-y-3">
        <Label className="text-2xl">Select multiple documents:</Label>
        <div className="space-y-2 ml-2">
          <div className="flex items-center gap-2">
            <Checkbox
              checked={settings?.isVerifyIdCard}
              onCheckedChange={(checked) =>
                updateSetting("isVerifyIdCard", checked)
              }
            />
            <Label>ID card</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              checked={settings?.isVerifyPassport}
              onCheckedChange={(checked) =>
                updateSetting("isVerifyPassport", checked)
              }
            />
            <Label>Passport</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              checked={settings?.isVerifyDrivingLicense}
              onCheckedChange={(checked) =>
                updateSetting("isVerifyDrivingLicense", checked)
              }
            />
            <Label>Driving License</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              checked={settings?.isVerifyBirthCertificate}
              onCheckedChange={(checked) =>
                updateSetting("isVerifyBirthCertificate", checked)
              }
            />
            <Label>Birth certificate</Label>
          </div>
          <div className="flex items-center gap-2">
            <Checkbox
              checked={settings?.isVerifyResidencePermit}
              onCheckedChange={(checked) =>
                updateSetting("isVerifyResidencePermit", checked)
              }
            />
            <Label>Residence permit</Label>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.isShowSignature}
          onCheckedChange={(checked) =>
            updateSetting("isShowSignature", checked)
          }
        />
        <Label className="text-2xl">Signature</Label>
      </div>

      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.isShowInviteGuests}
          onCheckedChange={(checked) =>
            updateSetting("isShowInviteGuests", checked)
          }
        />
        <Label className="text-2xl">Invite guests</Label>
      </div>

      <div className="flex items-center gap-2">
        <Switch
          checked={settings?.skipDocuments}
          onCheckedChange={(checked) => updateSetting("skipDocuments", checked)}
        />
        <Label className="text-2xl">Skip button</Label>
      </div>
    </div>
  );
};
